

import { startCase } from 'lodash-es';
import React from 'react';

import { Chip } from '@mui/material';

import Amex from './icons/american_express';
import ApplePay from './icons/apple_pay';
import Diners from './icons/diners_club';
import Discover from './icons/discover';
import GooglePay from './icons/google_pay';
import Mastercard from './icons/mastercard';
import ShopPay from './icons/shop_pay';
import Visa from './icons/visa';

export type PaymentOptionType = Queries.ShopifyStorefront_CardBrand | Queries.ShopifyStorefront_DigitalWallet;

export const PaymentOptionIcon = ({ option, sx }: { option: PaymentOptionType, sx?: React.CSSProperties }) => {
    const goodCase = startCase(option.toLowerCase());

    let icon: React.ReactNode
    if (option === 'VISA') icon = <Visa sx={sx} />
    else if (option === 'AMERICAN_EXPRESS') icon = <Amex sx={sx} />
    else if (option === 'MASTERCARD') icon = <Mastercard sx={sx} />
    else if (option === 'APPLE_PAY') icon = <ApplePay sx={sx} />
    else if (option === 'GOOGLE_PAY') icon = <GooglePay sx={{ ...sx }} />
    else if (option === 'DISCOVER') icon = <Discover sx={{ ...sx }} />
    else if (option === 'DINERS_CLUB') icon = <Diners sx={{ ...sx }} />
    else if (option === 'SHOPIFY_PAY') icon = <ShopPay sx={{ ...sx }} />
    else icon = <Chip variant='outlined' color="default" label={goodCase} />

    return icon;

    // return <Tooltip title={goodCase} placement="top">{icon}</Tooltip>
}
